import {
  LicenseInfo as MuiLicenseInfo,
  muiXTelemetrySettings,
} from "@mui/x-license";
import { AdminApp } from "app/AdminApp";
import { useApp } from "app/appService";
import { PortalApp } from "app/PortalApp";
import { BundleIds } from "app/shared/constants";

MuiLicenseInfo.setLicenseKey(window.RUNTIME_CONFIG.muiLicenseKey);
muiXTelemetrySettings.disableTelemetry();

export const App = () => {
  const { bundleId } = useApp();
  switch (bundleId) {
    case BundleIds.MEDONBOARD_ADMIN:
    case BundleIds.MEDACT_ADMIN:
    case BundleIds.MEDLEAVE_ADMIN:
    case BundleIds.RELEASE_MANAGER_ADMIN:
      return <AdminApp />;
    case BundleIds.MEDONBOARD_PORTAL:
      return <PortalApp />;
    default:
      return null;
  }
};
